import { FC } from "react";
import { MainListItemStyled } from "@/shared";

export const SavingGoalsListNoData: FC = () => {
  return <MainListItemStyled>No saving goals</MainListItemStyled>;
};
